const animationElements = [
  {
    id: 'j-pen-animation',
    path: './assets/images/front/animation/pen.json',
    loop: false
  }, {
    id: 'j-service-marquee',
    path: './assets/images/front/animation/service-marquee.json',
    loop: true
  }, {
    id: 'j-balloon-animation',
    path: './assets/images/front/animation/balloon.json',
    loop: true
  }, {
    id: 'j-service-person',
    path: './assets/images/front/animation/service-person.json',
    loop: true
  }, {
    id: 'j-service-person-mobile',
    path: './assets/images/front/animation/service-person.json',
    loop: true
  }, {
    id: 'j-pig-animation',
    path: './assets/images/front/animation/flying-pig.json',
    loop: true
  }, {
    id: 'j-deposit-animation',
    path: './assets/images/front/animation/deposit.json',
    loop: true
  }, {
    id: 'j-sofa-animation',
    path: './assets/images/front/animation/sofa.json',
    loop: true
  },
];

animationElements.forEach((element) => {

  const animationContainer = document.getElementById(element.id);

  if (!animationContainer) {
    return;
  }

  const animationData = {
    container: animationContainer,
    renderer: 'svg',
    loop: element.loop,
    autoplay: true,
    path: element.path,
    rendererSettings: {
      className: 'c-animation',
    },
  };

  const animationService = lottie.loadAnimation(animationData);
});
